import type { FunnelStepEvent } from '@/utilities/dataLayer/models';
import { pushDataLayer } from '@/utilities/dataLayer/push';

import { DATA_LAYER_EVENTS } from '@/constants/dataLayer';

type TrackFunnelStepParams = Omit<FunnelStepEvent, 'event'>;

export const trackFunnelStep = (params: TrackFunnelStepParams): void => {
    pushDataLayer({
        event: DATA_LAYER_EVENTS.FUNNEL_STEP,
        ...params
    });
};
